import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchBox, UseSearchBoxProps } from 'react-instantsearch'

import { useSearchContext } from '@components/context/SearchContext'

export default function CustomSearchBox(props: UseSearchBoxProps) {
  const { query, refine } = useSearchBox(props)
  const { t } = useTranslation('revamp')

  const [inputValue, setInputValue] = useState(query)
  const { setSearchText } = useSearchContext()

  function setQuery(newQuery: string) {
    setInputValue(newQuery)
    setSearchText(newQuery)
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      refine(inputValue)
    }, 200)

    return () => clearTimeout(timeoutId)
  }, [inputValue])

  return (
    <div className='relative w-full h-12 text-revamp-neutral-500'>
      <input
        className='w-full h-full pl-10 pr-4 py-2 rounded-full focus:outline-none placeholder-revamp-neutral-500'
        autoComplete='off'
        autoCorrect='off'
        autoCapitalize='off'
        placeholder={t('searchPlaceholder')}
        spellCheck={false}
        maxLength={512}
        type='search'
        value={inputValue}
        onChange={(event) => {
          setQuery(event.currentTarget.value)
        }}
        // @ts-expect-error - enterKeyHint is not typed
        enterKeyHint='search'
        autoFocus
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            // Hide keyboard on Enter key press
            ;(event.target as HTMLInputElement).blur()
          }
        }}
      />
      <div className='absolute inset-y-0 flex left-3'>
        <MagnifyingGlassIcon className='my-auto w-5 h-5' />
      </div>
      {inputValue && (
        <button
          type='button'
          onClick={() => setQuery('')}
          className='absolute inset-y-0 flex right-3'
        >
          <XMarkIcon className='my-auto w-5 h-5' />
        </button>
      )}
    </div>
  )
}
